import React from 'react'
import createReactClass from 'create-react-class'

/**
 * A html checkbox creator
 */
var OpeCheckbox = createReactClass({
	getDefaultProps: function() {
		return {
			checkboxClassName: ""
		};
	},

	checkboxChanged: function(event) {
		this.props.callback(event);
	},

	render: function() {
		var className = "ope-checkbox " + this.props.checkboxClassName;

		return (
			<div className={className}>
				<input type="checkbox" id={this.props.checkboxId} onChange={this.checkboxChanged} checked={this.props.isChecked} />
				<label className="ope-checkbox__label" htmlFor={this.props.checkboxId}>{this.props.labelText ? this.props.labelText : null }</label>
				{this.props.children}
			</div>
		);
	}
});

export default OpeCheckbox;
